import React from "react";
import {
  Container,
  Avatar,
  Typography,
  Grid,
  Paper,
  IconButton,
  Box,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

import { useState, useEffect } from "react";
import axios from "axios";
import { removeStudentAction } from "../../actions/removeStudent";
import { useClass, useSetClass } from "../../globals/ClassContext";

const { REACT_APP_DEBUGGER_SERVER_URL } = process.env;

export default function Student(props) {
  const classroom = useClass();
  const setClass = useSetClass();

  const [singleUser, setSingleUser] = useState({});

  const { studentID } = props;
  const { setConfirmationEffect } = props;
  const { handleConfirmationOpen } = props;
  const { setConfirmationText } = props;

  useEffect(() => {
    async function fetchStudent() {
      const res = await axios
        .get(`${REACT_APP_DEBUGGER_SERVER_URL}/user/${studentID}`)
        .catch((error) => {
          console.log(error);
        });
      setSingleUser(res.data);
    }
    fetchStudent();
  }, [studentID]);

  const handleRemove = (event) => {
    setConfirmationText(
      "Would you like to remove " + singleUser.name + " from this class?"
    );
    // Will not work correctly if the function to run on confirmation is not passed an anounymous reference
    setConfirmationEffect(() => removeStudent);
    handleConfirmationOpen();
    event.stopPropagation();
  };

  const removeStudent = () => {
    removeStudentAction(classroom._id, studentID, setClass);
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ paddingTop: "4px" }}>
      <Paper elevation={3} sx={{ padding: "4px" }}>
        <Grid
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            flex: "auto",
          }}
        >
          <Grid container direction="row" alignItems="center">
            {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" /> */}
            <Typography
              variant="subtitle2"
              sx={{
                margin: "5px 0px",
                paddingLeft: "10px",
                margin: 0,
              }}
            >
              {singleUser.name}
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                margin: "5px 0px",
                fontSize: "0.75em",  
                paddingLeft: "10px",
                margin: 0,
              }}
            >
              {singleUser.email}
            </Typography>
          </Grid>
          <Typography
            variant="subtitle1"
            sx={{ margin: "5px 0px", fontSize: "1.1rem" }}
          >
            {singleUser.grade}
          </Typography>
          <IconButton color="primary" arialabel="remove" onClick={handleRemove}>
            <RemoveCircleIcon />
          </IconButton>
        </Grid>
      </Paper>
    </Container>
  );
}
